import Staff from '@/api/home/staff'
import { baseState, baseMutations } from '@/store/mixins'

export const state = {
  ...baseState,
  profile: []
}

export const getters = {}

export const mutations = {
  ...baseMutations,
  RECEIVE_PROFILES(state, data) {
    state.profile = data
  }
}

export const actions = {
  fetchProfile(context = {}) {
    return Staff.getProfile().then(response => {
      context.commit('RECEIVE_PROFILES', response.data)
      return Promise.resolve(response)
    })
  },

  uploadPhoto(context, data) {
    return Staff.uploadPhoto(data)
  },
  changePwd(context, data) {
    return Staff.changePassword(data)
  }
}
